import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import { DELIVERY, FAVORITE, PICKUP, RECENT_ORDER, REORDER, ACCOUNT_ORDER_HISTORY, ACCOUNT_FAVROITES } from '../../../constants/App';
import { productString, getOrderTypeByFulfillmentType } from '../../Analytics/AnalyticsNew';
import { multipleAndCheck, multipleOrCheck, ternaryCheck } from '../../../Utils/WindowUtils';
import { getUtcTime } from '../../../Utils/pageUtils';
import {getRecommendationSourceAnalytics} from '../../../Utils/analyticsUtils';
/**
 * Prepares payload for add to bag API
 * @param {Object} orderViewModel - orderViewModel object
 * @param {String} addItemAsyncApi - API endpoint
 * @param {Object} item - item object
 * @param {String} siteName - site name
 * @returns {Object} payload
 */

export const preparePayloadForAddToBag = (
  orderViewModel,
  addItemAsyncApi,
  item,
  siteName,
  dataSource,
) => {
  const deliveryPayload = {};

  if (_isEqual(orderViewModel.orderType?.toLowerCase(), DELIVERY)) {
    const { DeliveryAddress } = orderViewModel;
    deliveryPayload.StreetAddressLine1 = DeliveryAddress.StreetAddressLine1;
    deliveryPayload.StreetAddressLine2 = '';
    deliveryPayload.City = DeliveryAddress.City;
    deliveryPayload.State = DeliveryAddress.State;
    deliveryPayload.Zip = DeliveryAddress.Zip;
    deliveryPayload.Country = DeliveryAddress.Country;
  }

  const comboItems = {};
  const combos = item?.combo;
  let isCombo = false;

  if (multipleAndCheck(combos , multipleOrCheck(combos?.comboName , combos?.ComboName))) {
    comboItems.combo = combos;
    const comboItemsList = combos.items;
    isCombo = true;
    comboItems.combo.ComboItems = comboItemsList;
  }
  const getBundleItems = (selectedItem) => {
    const bundleItems = [];
    const mainItems = { ...selectedItem };

    let bundleList  = null;
    if (mainItems.combo) {
      bundleList = mainItems.combo.ComboItems;
      delete mainItems.combo;
    }
    mainItems.productName = selectedItem.name;
    bundleItems.push(mainItems);

    if (bundleList) bundleItems.push(...bundleList);
    return bundleItems;
  };
  return {
    ...deliveryPayload,
    apiEndpoint: addItemAsyncApi,
    DatasourceId: dataSource,
    CartId: item?.orderId,
    StoreId: orderViewModel.store.id,
    OrderType: orderViewModel.orderType ?? PICKUP,
    MergeCart: true,
    SiteName: siteName,
    IsModalView: true,
    IsAccordionOpen: false,
    IsRecentOrder: false,
    OrderId: item?.orderId,
    IsAddToBag: false,
    ProductId: item?.productId,
    IsAddToBagFromRecentOrder: true,
    AddItemModel: {
      IsReactResponse: true,
      items: item?.isBundleItem ? null : {
        AddCartItems: [
          {
            ...comboItems,
            analytics: {
              CategoryId: item?.categoryId,
              CategoryName: item?.categoryName,
              ProductName: item?.analytics?.productName ?? '',
              IsCookie: item?.isCookie,
              masterProductId: item?.analytics?.masterProductId ?? null,
              ProductOriginSource: RECENT_ORDER,
              ComboOriginSource: ternaryCheck(isCombo , REORDER , "n/a"),
              SubCategory : item?.analytics?.subCategory,             
              Size : item?.analytics?.size,
              isSoup : item?.analytics?.isSoup,
              addToBagSource: ACCOUNT_ORDER_HISTORY,
              exceededSugarLevel: item?.analytics?.exceededSugarLevel,
              SubCategoryId : item?.analytics?.subcategoryId,
              isQuickAddOn : item?.analytics?.isQuickAddOn,
              isQuickSell : item?.analytics?.isQuickSell, 
              ...(item?.analytics?.isShowEdit !== null ? { isShowEdit: item?.analytics?.isShowEdit } : {}),
            },
            options:ternaryCheck(!_isEmpty(item?.options) , item?.options , undefined),
            productId: item?.productId,
            productName: item?.name,
            quantity: 1,
            imageUrl: '/ns/images/Menu/USA/ENG/Category_767x767_BlackForestHam_Sandwiches_@1x.jpg',
          },
        ],
      },
      bundles: item?.isBundleItem ? {
        AddBundleItems: [{
          bundleID: item?.combo?.comboId,
          bundleName: item?.combo?.comboName,
          itemType: '',
          bundleMasterPromotionId: "",
          BundleItems: getBundleItems(item),

        }]
      } : null,
      CartId: orderViewModel.currentOrder.cartId,
      StoreId: orderViewModel.store.id,
      LocationId: ternaryCheck(item?.itemDetails?.locationId, item?.itemDetails?.locationId, orderViewModel.store.id),
      IsKidsMeal: item?.isKidsMeal,
      pricingScheme: '1',
      fulfillmentType: ternaryCheck(orderViewModel.orderType, orderViewModel.orderType, PICKUP),
      dineIn: false,
      curbside: {
        curbsideInstructions: ' ',
      },
      orderInstructions: ' ',
      siteName: siteName,
    },
  };
};

/**
 * Prepares payload for unavailable modal
 * @param isRecentOrderPage - true if the modal is shown on recent order page
 * @param cartItemId - cart item id
 * @param orderViewModel - orderViewModel object
 * @param siteName - site name
 * @param itemsData - itemsData object
 * @returns {Object} payload
 */
export const preparePayloadForUnavailableModal = (isRecentOrderPage,isRecentorderReorder,
  cartItemId, orderViewModel, itemsData, order_Detail, ...rest
) => {
  const { siteName, storeId, orderType, deliveryAddress } = order_Detail;
  const [removeAndContinue, bundleItemId = [], isSwitchStoreAddress, dataSourceId] = rest;
  const isDelivery = isSwitchStoreAddress == 'delivery';
  if (removeAndContinue) {
    const request = {
      LocationId: orderViewModel.store.id,
      FulfillmentType: ternaryCheck(isSwitchStoreAddress, isSwitchStoreAddress, orderViewModel.orderType),
      CartId: orderViewModel.currentOrder.cartId,
      ItemUnavailableList: orderViewModel.ItemUnavailableList,
      CartItemId: cartItemId,
      BundleItemId: bundleItemId,
      IsReact: true,
      ...(ternaryCheck(isSwitchStoreAddress, { IsCartPage: true, DatasourceId: dataSourceId, IsQuickaddon: true, CurrentTierLevel: orderViewModel?.Analytics?.tierLevel, userLocalTime: getUtcTime() }, {})),
      SiteName: siteName
    };
    if (orderViewModel.orderType === 'delivery' || isDelivery) {
      request.LocationId = ternaryCheck(isDelivery, orderViewModel.switchDeliveryStoreId, orderViewModel.store.id);
      request.StreetAddressLine1 = ternaryCheck(isDelivery, orderViewModel.switchDeliveryAddress.StreetAddressLine1, orderViewModel.DeliveryAddress.StreetAddressLine1);
      request.StreetAddressLine2 = ternaryCheck(isDelivery, orderViewModel.switchDeliveryAddress.StreetAddressLine2, orderViewModel.DeliveryAddress.StreetAddressLine2);
      request.City = ternaryCheck(isDelivery, orderViewModel.switchDeliveryAddress.City, orderViewModel.DeliveryAddress.City);
      request.State = ternaryCheck(isDelivery, orderViewModel.switchDeliveryAddress.State, orderViewModel.DeliveryAddress.State);
      request.Zip = ternaryCheck(isDelivery, orderViewModel.switchDeliveryAddress.Zip, orderViewModel.DeliveryAddress.Zip);
      request.Country = ternaryCheck(isDelivery, orderViewModel.switchDeliveryAddress.Country, orderViewModel.DeliveryAddress.Country);
      request.DirectDelivery = ternaryCheck(isDelivery, orderViewModel.switchDeliveryAddress.DirectDelivery, orderViewModel.DeliveryAddress.DirectDelivery);
      request.QuoteId = ternaryCheck(isDelivery, orderViewModel.switchDeliveryAddress.QuoteId, orderViewModel.DeliveryAddress.QuoteId);
    }

    return request;
  }
  const mergeCart = ternaryCheck(Number(orderViewModel.currentOrder.cartQuantity) > 0 , true , false);
  const mergeCartID = ternaryCheck(mergeCart , orderViewModel.currentOrder.cartId , '');
  const city = _get(deliveryAddress, ['deliveryAddress', 'city'], '');
  const state = _get(deliveryAddress, ['deliveryAddress', 'state'], '');
  const zip = _get(deliveryAddress, ['deliveryAddress', 'zip'], '');
  const country = _get(deliveryAddress, ['deliveryAddress', 'country'], '');
  const streetAddressLine1 = _get(deliveryAddress, ['deliveryAddress', 'streetAddressLine1'], '');
  const streetAddressLine2 = _get(deliveryAddress, ['deliveryAddress', 'streetAddressLine2'], '');
  const quoteId = _get(deliveryAddress, ['quoteId'], '');
  const isMenuPage = window.location.href.includes('menu');

  const commonPayload = {
    StoreId: orderViewModel.store.id || storeId,
    SiteName: siteName,
    IsReactResponse: true,
  };

  const recentOrderPayload = {
    ...commonPayload,
    OrderId: orderViewModel.currentOrder.cartId,
    CartId: cartItemId,
    StreetAddressLine1: streetAddressLine1 || orderViewModel.DeliveryAddress.StreetAddressLine1,
    StreetAddressLine2: streetAddressLine2 || orderViewModel.DeliveryAddress.StreetAddressLine2,
    City: city || orderViewModel.DeliveryAddress.City,
    State: state || orderViewModel.DeliveryAddress.State,
    Zip: zip || orderViewModel.DeliveryAddress.Zip,
    Country: country || orderViewModel.DeliveryAddress.Country,
    DirectDelivery: ternaryCheck(orderType == 'delivery', true, orderViewModel.DeliveryAddress.DirectDelivery),
    QuoteId: quoteId || orderViewModel.DeliveryAddress.QuoteId,
    OrderType: orderType || orderViewModel.orderType,
    IsAddToBag: !isRecentorderReorder,
    ProductId: _get(itemsData, 'productId', ''),
    CurrentCartId: '',
    MergeCart: mergeCart,
    MergeCartId: mergeCartID,
    OrderSourceType: RECENT_ORDER,
    ComboOriginSource: 'n/a',
    AddToBagSource: isMenuPage ? getRecommendationSourceAnalytics('orderagain'): ACCOUNT_ORDER_HISTORY,
  };

  const favOrderPayload = {
    ...commonPayload,
    CurrentOrderCartId: orderViewModel.currentOrder.cartId,
    ReorderedItemCartItemId: cartItemId,
    OrderSourceType: FAVORITE,
    ComboOriginSource: 'n/a',
    AddToBagSource: isMenuPage ? getRecommendationSourceAnalytics('favorite'): ACCOUNT_FAVROITES,
  };

  return ternaryCheck(isRecentOrderPage, recentOrderPayload, favOrderPayload);
};

export const updateDeliveryAddress = (successResult, mergeCart) => {
  if (successResult && !mergeCart) {
    orderViewModel.store.id = successResult.pickupLocationId;
    orderViewModel.DeliveryAddress.StreetAddressLine1 =
      successResult.deliveryAddress.streetAddressLine1;
    orderViewModel.DeliveryAddress.StreetAddressLine2 =
      successResult.deliveryAddress.streetAddressLine2;
    orderViewModel.DeliveryAddress.City = successResult.deliveryAddress.city;
    orderViewModel.DeliveryAddress.State = successResult.deliveryAddress.state;
    orderViewModel.DeliveryAddress.Zip = successResult.deliveryAddress.zip;
    orderViewModel.DeliveryAddress.Country = successResult.deliveryAddress.country;
    orderViewModel.DeliveryAddress.DirectDelivery = true;
    orderViewModel.DeliveryAddress.QuoteId = successResult.quoteId;
    orderViewModel.save();
  }
};

export const updateOrderType = (orderType, mergeCart) => {
  if (!mergeCart) {
    orderViewModel.orderType = orderType;
    orderViewModel.AnalyticsorderType = getOrderTypeByFulfillmentType(orderType);
    orderViewModel.save();
  }
};

export const updateStoreDetails = (data, mergeCart) => {
  orderViewModel.OrderSourceType = 'Re-Order';
  orderViewModel.currentOrder.itemAddedtoBag = 0;
  if (data.currentOrder && !mergeCart) {
    const storeNumber = data.currentOrder.storeId ? data.currentOrder.storeId.split('-') : [];
    orderViewModel.store.storeNumber = storeNumber.length > 0 ? storeNumber[0] : '';
    orderViewModel.store.satelliteNumber = storeNumber.length > 1 ? storeNumber[1] : '';
    orderViewModel.store.id = data.currentOrder.storeId;
    orderViewModel.store.address = data.currentOrder.storeAddress;
    orderViewModel.store.storeCountry = data.currentOrder.countryCode;
    if (data.currentOrder.store) {
      orderViewModel.store.address1 = data.currentOrder.store.locationAddress1;
      orderViewModel.store.address3 = data.currentOrder.store.locationAddress3;
      orderViewModel.store.stateProvCode = data.currentOrder.store.locationStateProv;
      orderViewModel.store.city = data.currentOrder.store.locationCity;
      orderViewModel.store.zip = data.currentOrder.store.locationZipCode;
      orderViewModel.store.postalCode = data.currentOrder.store.locationZipCode;
      orderViewModel.store.phoneNumber = data.currentOrder.store.phoneNumber;
    }
  }
  orderViewModel.IsSidesOrDrinksLimitReached = data.isSidesOrDrinksLimitReached;
  orderViewModel.save();
};

export const getProductsItems = (response, isLocatorPage = false) => {
  const list = response.map(listData => {
    const productDetails = {
      categoryName: _get(listData, ['analytics', 'categoryName'], ''),
      productName: _get(listData, ['analytics', 'productName'], ''),
      productId: _get(listData, ['productId'], ''),
      price: _get(listData, ['totalLineItemPrice'], 0),
      quantity: _get(listData, ['quantity'], 1),
      size: _get(listData, ['productName'], '')
    }
    return productString(
      listData,
      productDetails,
      '',
      isLocatorPage ? 'n/a' : 'account-order history',
      isLocatorPage ? _get(listData, ['analytics', 'productOriginSource'], '') : 'Recent Order',
    );
  });

  return [].concat(...list);
};


export const checkPreviousQuantity = (previousQuantity, successUrl) => {
  if (multipleAndCheck(previousQuantity == 0 , successUrl)) {
    window.location.href = window.location.origin + successUrl;
  }
}

export const setDeliveryAddressIfNotMerged = (mergeCart, setDeliveryAddress, reOrdeResponse) => {
  if(!mergeCart){
    setDeliveryAddress(reOrdeResponse.successResult)
  }
}

export const checkWebOrderAvailable = (store, dictionaryLabels, setModalData, setShowModal, setStoreResponse, setCurbsideShowModal) => {
  if (!store.isWebOrderAvailable) {
    //show web order modal
    const modal = {
      url: '',
      buttonText: dictionaryLabels.webOrderNotAvailableDownloadAppButtonText,
      title: dictionaryLabels.webOrderNotAvailableTitle,
      message: dictionaryLabels.webOrderNotAvailableMessage,
    };
    setModalData(modal);
    setShowModal(true);
  } else if (
    multipleOrCheck(
      multipleAndCheck(!store?.hasCurbside, store?.orderType === 'curbside'),
    multipleOrCheck(store?.hasCurbsideAfterHours,store?.curbSideLastCall),
    multipleAndCheck(store?.hasCurbsideBeforeHours , store?.hasCurbside)
    )) {
    setStoreResponse(store)
    setCurbsideShowModal(true);
  }
}

